import { WalletType } from '@/types/WalletType';

export function validateGlobalCca(wallet: WalletType) {
  return (
    wallet.isMainAccount &&
    wallet.currency === 'CLP' &&
    wallet.accountBranchName === 'GLOBAL_CARD' &&
    !!wallet?.accountNumber
  );
}

/**
 *
 * @param wallet user's main wallet
 * @param currency currency to validate if it is global 81
 * @returns a boolean indicating if it is global 81
 */
export function isGlobal81(wallet: WalletType, currency: string) {
  return (
    wallet.isMainAccount &&
    wallet.currency === currency &&
    wallet.accountBranchName === 'B2B_GLOBAL_81'
  );
}

export function validateGlobalAch(wallet: WalletType) {
  return (
    wallet.isMainAccount &&
    wallet.currency === 'COP' &&
    wallet.accountBranchName === 'B2B_GLOBAL_SEDPE' &&
    !!wallet?.accountNumber
  );
}
